import { _ } from '@portal-internet/core';

const reelsBreakpoints = (col) => {
    let breakpoints = {
        0: {
            slidesPerView: 2.1
        },
        320: {
            slidesPerView: 1.5,
            spaceBetween: 16,
            slidesPerGroup: 1
        },
        720: {
            slidesPerView: 3,
            spaceBetween: 16,
            slidesPerGroup: 3
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 16,
            slidesPerGroup: 4
        },
        1304: {
            slidesPerView: 4,
            spaceBetween: 24,
            slidesPerGroup: 4
        }
    };
    if (col === 8) {
        breakpoints = {
            0: {
                slidesPerView: 2.1
            },
            320: {
                slidesPerView: 2.3,
                spaceBetween: 12,
                slidesPerGroup: 2
            },
            720: {
                slidesPerView: 3.3,
                spaceBetween: 12,
                slidesPerGroup: 4
            },
            1024: {
                slidesPerView: 3.3,
                spaceBetween: 12,
                slidesPerGroup: 4
            },
            1920: {
                slidesPerView: 3.3,
                spaceBetween: 12,
                slidesPerGroup: 4
            }
        };
    }

    return breakpoints;
};

const informatiusDestacatsBreakpoints = (col) => {
    let breakpoints = {
        0: {
            slidesPerView: 2.1
        },
        320: {
            slidesPerView: 1.5,
            spaceBetween: 16,
            slidesPerGroup: 1
        },
        720: {
            slidesPerView: 3,
            spaceBetween: 16,
            slidesPerGroup: 3
        },
        1024: {
            slidesPerView: 4,
            spaceBetween: 16,
            slidesPerGroup: 4
        },
        1304: {
            slidesPerView: 4,
            spaceBetween: 24,
            slidesPerGroup: 4
        }
    };
    if (col === 8) {
        breakpoints = {
            0: {
                slidesPerView: 2.1
            },
            320: {
                slidesPerView: 2.3,
                spaceBetween: 12,
                slidesPerGroup: 2
            },
            720: {
                slidesPerView: 3.3,
                spaceBetween: 12,
                slidesPerGroup: 4
            },
            1024: {
                slidesPerView: 3.3,
                spaceBetween: 12,
                slidesPerGroup: 4
            },
            1920: {
                slidesPerView: 3.3,
                spaceBetween: 12,
                slidesPerGroup: 4
            }
        };
    }

    return breakpoints;
};

const getMeu3CatBreakpoints = () => ({
    600: {
        slidesPerView: 2,
        spaceBetween: 12,
        slidesPerGroup: 2
    },
    720: {
        slidesPerView: 3,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4
    }
});

const getDefaultBreakpoints = () => ({
    600: {
        slidesPerView: 2,
        spaceBetween: 12,
        slidesPerGroup: 2
    },
    720: {
        slidesPerView: 3,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4
    },
    1920: {
        slidesPerView: 5,
        spaceBetween: 16,
        slidesPerGroup: 5
    }
});

const getBreakpointsForMomentsClau = () => ({
    300: {
        slidesPerView: 2,
        spaceBetween: 12,
        slidesPerGroup: 2
    },
    720: {
        slidesPerView: 2.3,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    1024: {
        slidesPerView: 3.3,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    1304: {
        slidesPerView: 4.3,
        spaceBetween: 16,
        slidesPerGroup: 4
    },
    1920: {
        slidesPerView: 5.3,
        spaceBetween: 16,
        slidesPerGroup: 5
    }
});

const getBreakpointsForNoticiaAutor = () => ({
    0: {
        slidesPerView: 1.5,
        spaceBetween: 24
    },
    720: {
        slidesPerView: 2.5,
        spaceBetween: 24
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 24
    }
});

const getBreakpointsForDestacatVideo = () => ({
    0: {
        slidesPerView: 1.5,
        spaceBetween: 24
    },
    720: {
        slidesPerView: 2.5,
        spaceBetween: 24
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 24
    }
});

const getBreakpointsForMesLlegit = () => ({
    300: {
        slidesPerView: 1.5,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    720: {
        slidesPerView: 3.2,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    1024: {
        slidesPerView: 5,
        spaceBetween: 16,
        slidesPerGroup: 5
    },
    1303: {
        slidesPerView: 5,
        spaceBetween: 24,
        slidesPerGroup: 5
    },
    1440: {
        slidesPerView: 5,
        spaceBetween: 27,
        slidesPerGroup: 5
    }
});

const getBreakpointsForTiraVegueries = () => ({
    300: {
        slidesPerView: 2,
        spaceBetween: 8,
        slidesPerGroup: 2
    },
    720: {
        slidesPerView: 3,
        spaceBetween: 24,
        slidesPerGroup: 3
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 24,
        slidesPerGroup: 4
    },
    1440: {
        slidesPerView: 5,
        spaceBetween: 24,
        slidesPerGroup: 5
    },
    1920: {
        slidesPerView: 6,
        spaceBetween: 24,
        slidesPerGroup: 6
    }
});

const getBreakpointsForTiraFirmes = () => ({
    300: {
        slidesPerView: 1.5,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    720: {
        slidesPerView: 2.3,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4
    }
});

const getBreakpointsForTiraAnalisiFirmes = () => ({
    300: {
        slidesPerView: 2.5,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    720: {
        slidesPerView: 3.5,
        spaceBetween: 24,
        slidesPerGroup: 3
    },
    1024: {
        slidesPerView: 4.5,
        spaceBetween: 24,
        slidesPerGroup: 4
    },
    1304: {
        slidesPerView: 6,
        spaceBetween: 24,
        slidesPerGroup: 6
    }
});

const getBreakpointsForTiraAutors = () => ({
    300: {
        slidesPerView: 2,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    744: {
        slidesPerView: 3.2,
        spaceBetween: 24,
        slidesPerGroup: 3
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 24,
        slidesPerGroup: 4
    },
    1440: {
        slidesPerView: 5,
        spaceBetween: 24,
        slidesPerGroup: 5
    }
});

const getBreakpointsForTiraMomentsClau = () => ({
    300: {
        slidesPerView: 2.3,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    600: {
        slidesPerView: 2.3,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    720: {
        slidesPerView: 2,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    1024: {
        slidesPerView: 5,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    1440: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4
    },
    1920: {
        slidesPerView: 5,
        spaceBetween: 16,
        slidesPerGroup: 5
    }
});

const getBreakpointsForSliderCares = () => ({
    300: {
        slidesPerView: 2.1,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    375: {
        slidesPerView: 2.6,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    600: {
        slidesPerView: 3.9,
        spaceBetween: 16,
        slidesPerGroup: 4
    },
    720: {
        slidesPerView: 3.9,
        spaceBetween: 16,
        slidesPerGroup: 4
    },
    1024: {
        slidesPerView: 5.4,
        spaceBetween: 16,
        slidesPerGroup: 5
    },
    1440: {
        slidesPerView: 7,
        spaceBetween: 16,
        slidesPerGroup: 7
    },
    1920: {
        slidesPerView: 7,
        spaceBetween: 16,
        slidesPerGroup: 7
    }
});

const getBreakpointsForSliderCaresEleccionsBarca = () => ({
    300: {
        slidesPerView: 2.1,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    375: {
        slidesPerView: 2.3,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    600: {
        slidesPerView: 3.4,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    720: {
        slidesPerView: 3.6,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    900: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4
    },
    1440: {
        slidesPerView: 6,
        spaceBetween: 16,
        slidesPerGroup: 6
    },
    1920: {
        slidesPerView: 6,
        spaceBetween: 16,
        slidesPerGroup: 6
    }
});

const getBreakpointsForSliderCaresEleccionsBarcaObertura = () => ({
    300: {
        slidesPerView: 1.9,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    375: {
        slidesPerView: 2.1,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    600: {
        slidesPerView: 3.1,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    720: {
        slidesPerView: 3.3,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    900: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4
    },
    1024: {
        slidesPerView: 5,
        spaceBetween: 16,
        slidesPerGroup: 5
    },
    1440: {
        slidesPerView: 6,
        spaceBetween: 16,
        slidesPerGroup: 6
    },
    1920: {
        slidesPerView: 6,
        spaceBetween: 16,
        slidesPerGroup: 6
    }
});

const getBreakpointsForCameres = () => ({
    400: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    720: {
        slidesPerView: 2.3,
        spaceBetween: 32,
        slidesPerGroup: 2
    },
    1024: {
        slidesPerView: 3,
        spaceBetween: 32,
        slidesPerGroup: 3
    },
    1440: {
        slidesPerView: 3,
        spaceBetween: 32,
        slidesPerGroup: 3
    }
});

const getBreakpointsForSliderImatgesLightbox = () => ({
    0: {
        slidesPerView: 1.2,
        spaceBetween: 12,
        slidesPerGroup: 1
    },
    600: {
        slidesPerView: 2.2,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    1024: {
        slidesPerView: 3,
        spaceBetween: 24,
        slidesPerGroup: 3
    },
    1440: {
        slidesPerView: 3,
        spaceBetween: 24,
        slidesPerGroup: 3
    },
    1920: {
        slidesPerView: 4,
        spaceBetween: 24,
        slidesPerGroup: 4
    }
});

const getBreakpointsForPrevisionsRecents = () => ({
    200: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    720: {
        slidesPerView: 2.3,
        spaceBetween: 16,
        slidesPerGroup: 2
    },
    1024: {
        slidesPerView: 3.2,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    1440: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4
    }
});

const getBreakpointsForTaulaExtrems = () => ({
    200: {
        slidesPerView: 1.1,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    600: {
        slidesPerView: 1.5,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    720: {
        slidesPerView: 1.5,
        spaceBetween: 16,
        slidesPerGroup: 1
    }
});

const getBreakpointsForTiraMobile = () => ({
    600: {
        slidesPerView: 2,
        spaceBetween: 12,
        slidesPerGroup: 2
    },
    720: {
        slidesPerView: 3,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    1024: {
        slidesPerView: 3,
        spaceBetween: 24,
        slidesPerGroup: 3
    },
    1920: {
        slidesPerView: 3,
        spaceBetween: 32,
        slidesPerGroup: 3
    }
});

const getBreakpointsGraficBarres = () => ({
    0: {
        slidesPerView: 1.1,
        spaceBetween: 12,
        slidesPerGroup: 1
    },
    720: {
        slidesPerView: 2,
        spaceBetween: 12,
        slidesPerGroup: 2
    },
    944: {
        slidesPerView: 3,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    1440: {
        slidesPerView: 4,
        spaceBetween: 24,
        slidesPerGroup: 4
    }
});

const getTiraEclipsiBreakpoints = () => ({
    0: {
        slidesPerView: 2.1
    },
    320: {
        slidesPerView: 1.5,
        spaceBetween: 16,
        slidesPerGroup: 1
    },
    720: {
        slidesPerView: 3,
        spaceBetween: 16,
        slidesPerGroup: 3
    },
    1024: {
        slidesPerView: 4,
        spaceBetween: 16,
        slidesPerGroup: 4
    },
    1304: {
        slidesPerView: 4,
        spaceBetween: 24,
        slidesPerGroup: 4
    }
});

const getPropsSwiper = (format, col) => {
    let breakpoints = getDefaultBreakpoints();

    switch (format) {
        case 'moments-clau':
            breakpoints = getBreakpointsForMomentsClau();
            break;
        case 'noticiaAutor':
            breakpoints = getBreakpointsForNoticiaAutor();
            break;
        case 'destacatVideo':
            breakpoints = getBreakpointsForDestacatVideo();
            break;
        case 'mes-llegit':
            breakpoints = getBreakpointsForMesLlegit();
            break;
        case 'tira_vegueries':
            breakpoints = getBreakpointsForTiraVegueries();
            break;
        case 'tira_firmes':
            breakpoints = getBreakpointsForTiraFirmes();
            break;
        case 'tira_analisi_firmes':
            breakpoints = getBreakpointsForTiraAnalisiFirmes();
            break;
        case 'tira_autors':
            breakpoints = getBreakpointsForTiraAutors();
            break;
        case 'momentsclau':
            breakpoints = getBreakpointsForTiraMomentsClau();
            break;
        case 'cameres':
            breakpoints = getBreakpointsForCameres();
            break;
        case 'slider_imatges_lightbox':
            breakpoints = getBreakpointsForSliderImatgesLightbox();
            break;
        case 'previsionsRecents':
            breakpoints = getBreakpointsForPrevisionsRecents();
            break;
        case 'taulaExtrems':
            breakpoints = getBreakpointsForTaulaExtrems();
            break;
        case 'poster-reel':
            breakpoints = reelsBreakpoints(col);
            break;
        case 'poster-informatiu-destacat':
            breakpoints = informatiusDestacatsBreakpoints(col);
            break;
        case 'slider_cares':
            breakpoints = getBreakpointsForSliderCares();
            break;
        case 'slider_cares_barca':
            breakpoints = getBreakpointsForSliderCaresEleccionsBarca();
            break;
        case 'slider_cares_barca_obertura':
            breakpoints = getBreakpointsForSliderCaresEleccionsBarcaObertura();
            break;
        case 'tiraMobile':
            breakpoints = getBreakpointsForTiraMobile();
            break;
        case 'eleccionsGraficBarres':
            breakpoints = getBreakpointsGraficBarres();
            break;
        case 'meu3cat':
            breakpoints = getMeu3CatBreakpoints();
            break;
        case 'tira_eclipsi':
            breakpoints = getTiraEclipsiBreakpoints();
            break;
        default:
            break;
    }

    return {
        spaceBetween: 12,
        slidesPerView: 1.3,
        slidesPerGroup: 1,
        freeMode: true,
        watchSlidesProgress: true,
        simulateTouch: false,
        breakpoints: breakpoints
    };
};

export { getPropsSwiper };
